import angular from 'angular';

import RwSubordinatesDropdownComponent from './rw-subordinates-dropdown-component';

export default angular
  .module('rw-subordinates-dropdown', [])
  .component('rwSubordinatesDropdown', new RwSubordinatesDropdownComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/components/rw-subordinates-dropdown/rw-subordinates-dropdown-module.js